import {createReducer, on} from '@ngrx/store';
import {IMaintenanceModeState} from '../models/maintenance-mode-state.model';
import {maintenanceMode} from './maintenance-mode.actions';

const initialState: IMaintenanceModeState = {
  isMaintenanceMode: false,
};

export const maintenanceModeReducer = createReducer(
  initialState,
  on(maintenanceMode, (state, {MaintenanceModeStatus}) => {
    return {
      ...state,
      isMaintenanceMode: MaintenanceModeStatus,
    };
  })
);
